<template lang="pug">
  v-row
    v-col(cols=12)
      h2.mb-2
        span(v-if="!task") Ответы
        span(v-else v-html="task.task_title")
      v-sheet.transparent(max-width="400")
        AutocompleteEnrollment(
          v-if="courseId"
          v-model="enrollmentId"
          outlined :rounded="false"
          clearable
          :courseId="Number(courseId)"
          hide-details
        )
        .mt-2
        SelectGroup.pt-2(
          v-if="enrollmentId"
          v-model="groupId"
          :course="Number(courseId)"
          filled hide-details outlined  flat clearable
          :enrollment="enrollmentId"
        )
      template(v-if="task")
        p(v-html="task.description")
    v-col(cols=12)
      v-skeleton-loader(
        v-if="loading.init"
        type="card@5"
      )
      div(v-else)
        v-card(
          v-for="unit in task.task_units"
          :key="unit.id"
        ).sdo-card.mb-4.pa-3
          v-card-title(v-html="unit.title")
          v-card-text
            span(v-html="unit.description")
            task-unit-type-wrap(
              :task-unit="unit"
              #default="{ component }"
            )
              component(
                :is="component"
                :task="task"
                :value="unit"
                analytic
              )
</template>

<script>
import TaskUnitTypeWrap from '@/modules/Groups/components/TaskUnitTypeWrap.vue';
import AutocompleteEnrollment from '@/components/InputFields/enrollment/AutocompleteEnrollment.vue';
import SelectGroup from '@/components/InputFields/group/SelectGroup.vue';

export default {
  components: {
    TaskUnitTypeWrap,
    AutocompleteEnrollment,
    SelectGroup,
  },
  data: () => ({
    loading: {
      init: true,
    },
    task: null,
    enrollmentId: null,
    groupId: null,
  }),
  computed: {
    taskId() {
      return this.$route.params.id;
    },
    courseId() {
      return this.$route.query.courseId;
    },
  },
  watch: {
    enrollmentId() {
      this.fetchTask();
    },
    groupId() {
      this.fetchTask();
    },
  },
  created() {
    this.fetchTask();
  },
  methods: {

    async fetchTask() {
      this.loading.init = true;
      const { data } = await this.$api.tasks.taskStatistics({
        task_id: this.taskId, prior_record_id: this.enrollmentId, group_id: this.groupId,
      });
      [this.task] = data.data.map((item) => {
        const itemData = Object.values(item).find((i) => typeof i === 'object');
        return {
          ...itemData,
          task_units: Object.values(itemData.task_units).sort((a, b) => a.ordinal - b.ordinal)
            .map((el) => ({
              ...el,
              possible_answers: Object.values(el.possible_answers).map((i) => ({
                id: i.id,
                name: i.name,
                user_selected: i.user_selected,
                correct_answer: i.correct_answer,
                total_user_choice: i.count_answer,
              })),
            })),
          total_journals: item.journals_count,
          total_answers: item.total_answers,
        };
      });
      this.loading.init = false;
    },
  },
};
</script>
